module.exports = __webpack_public_path__ + "img/CUFFLTBI.3c6c2d59.jpg";